import axios from './request'

export function fetchSearchLableMapping(params) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/search/searchlablemapping', {
    ...params
  })
}
